import { useState } from "react"

// Von den GIS-Layern gefetchte Chartworld-GeoJSONs; State liegt hier, weil
// auch VoyagePlanner und Pathfinder mitlesen.
export function useGisData() {
  const [cwPortGeojson, setCwPortGeojson] = useState(null)
  const [rnwLegs, setRnwLegs] = useState(null)
  const [cwRegionGeojson, setCwRegionGeojson] = useState(null)
  const [cwRestrictionGeojson, setCwRestrictionGeojson] = useState(null)
  const [cwPilotStationGeojson, setCwPilotStationGeojson] = useState(null)
  const [cwViaAreasGeojson, setCwViaAreasGeojson] = useState(null)
  const [cwLegsToViaAreasGeojson, setCwLegsToViaAreasGeojson] = useState(null)

  return {
    cwPortGeojson,
    setCwPortGeojson,
    rnwLegs,
    setRnwLegs,
    cwRegionGeojson,
    setCwRegionGeojson,
    cwRestrictionGeojson,
    setCwRestrictionGeojson,
    cwPilotStationGeojson,
    setCwPilotStationGeojson,
    cwViaAreasGeojson,
    setCwViaAreasGeojson,
    cwLegsToViaAreasGeojson,
    setCwLegsToViaAreasGeojson,
  }
}
